<template>
    <div class="header">
        <b-navbar toggleable="lg"  class="nav-bar">
           
            <b-navbar-brand to="/">
                <figure>
                    <b-img fluid :src="image" alt="My rainbow"></b-img>
                </figure>
                <h1>Our Rainbow</h1>
            </b-navbar-brand>
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav v-for="(cat, index) in categories" :key="cat.id">
                    <b-link :to="'/' + cat.id" :style="{color: STYLES[index].color}">{{cat.name}}</b-link>
                </b-navbar-nav>

                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
                    <b-nav-item to="/login" exact v-if="!isLoggedIn">Đăng Nhập</b-nav-item>
                    <b-nav-item to="#" @click.prevent="logout" v-if="isLoggedIn">Đăng Xuất</b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>
import { firebase, auth } from '../../firebase/firebaseConfig'
import { store, STYLES } from '../../firebase/categories'

export default {
    data() {
        return{
            isLoggedIn: false,
            auth: auth,
            store,
            STYLES,
            image: require('../../assets/my_rainbow_5.jpg')
        }
    },
    computed: {
        categories () { 
            return this.store.categories 
        },
    },
    methods: {
        logout() {
            firebase.auth().signOut().then(() => {
                this.$router.push('/login')
                this.isLoggedIn = false
            })
        }
    },
    watch: {
        'auth.user' (user) {
            const vm = this;
            if (user) {
                vm.isLoggedIn = true
            }
        }
    },
    
}
</script>

<style scoped lang="scss">
   @import '../../styles/components/navigation/Header.scss'
</style>